module.exports = __webpack_public_path__ + "static/media/icon_datasource.e686d50b.svg";